<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <confirm-box ref="confirm"></confirm-box>
        <div class="row">
            <div class="d-none d-lg-block col-lg-2"></div>
            <div class="col-12 col-lg-8">
                <h1>District Management</h1>
                <p>By adding districts here, any user from that email address will be granted access. To manage the district's memberships,
                    use the <a href="#/admin/dist-users">District User Management</a> page. The <a href="#/admin/users">User Management</a> 
                    page has precedence over these settings.</p>
                <ul class="list-group">
                    <li v-for="(d, indx) in districts" class="list-group-item d-block">
                        <template v-if="editing == d.id">
                            <admin-district-form 
                                :value="districts[indx]"
                                @cancel="editing = -1"
                                @input="updated(indx, $event)"
                                >
                            </admin-district-form>
                        </template>
                        <template v-else>
                            <div class="d-flex">
                                <div class="align-self-center me-3">
                                    <button type="button" class="btn btn-secondary btn-sm me-1" @click="askDel(d.id)" :disabled="!d.deletable"><i class="fa-solid fa-trash-can"></i></button>
                                    <button type="button" class="btn btn-secondary btn-sm me-1" @click="editing = d.id"><i class="fa-solid fa-pen-to-square"></i></button>
                                </div>
                                <div class="d-inline-block align-self-center">
                                    <h5 class="text-primary m-0">{{ d.name }}</h5>
                                    <h6 class="font-italic text-muted m-0">{{ d.domain }}</h6>
                                </div>
                            </div>
                        </template>
                    </li>
                    <li class="list-group-item d-flex">
                        <admin-district-form @input="addDistrict" ref="newDist"></admin-district-form>
                    </li>
                </ul>
                <div class="mt-4">
                    <home-button></home-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style></style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import AdminDistrictForm from "./AdminDistrictForm";
import ConfirmBox from './ConfirmBox';
import HomeButton from './HomeButton';

export default {
    components: { 
        Loading,
        AdminDistrictForm, 
        ConfirmBox,
        HomeButton,
     },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/admin/districts')
            .then(response => { 
                this.districts = response.data;
                console.log(this.districts);
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    data() {
        return {
            isLoading: false,

            districts: [],
            editing: -1,
            delegating: -1
        };
    },

    methods: {
        askDel: function(id) {
            this.$refs.confirm.show({
                title: 'Delete District',
                content: 'Are you sure you would like to delete this district?',
                callback: () => this.del(id),
            });
        },
        del: function(id) {
            this.isLoading = true;
            axios
                .delete(`/api/admin/districts/${id}`)
                .then(response => {
                    this.districts = this.districts.filter((dist) => dist.id != id);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        addDistrict: function(e) {
            this.districts.push(e);
            this.$refs.newDist.clear();
        },

        updated: function(index, event) {
            this.districts[index] = event;
            this.editing = -1;
        }
    }
}
</script>

